// Generated types for NodeAPI
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI, NeoNodeWriteAPI } from './neonode';
import { NeoNodeReadAPISchemaObject, NeoNodeWriteAPISchemaObject } from './neonode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface NodeAPIReadAPI extends NeoNodeReadAPI {
}

export interface NodeAPIWriteAPI extends NeoNodeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const NodeAPIReadAPISchemaObject = NeoNodeReadAPISchemaObject.extend({}).passthrough();
export const NodeAPIReadAPISchema: z.ZodType<NodeAPIReadAPI> = NodeAPIReadAPISchemaObject;

export const NodeAPIWriteAPISchemaObject = NeoNodeWriteAPISchemaObject.extend({}).passthrough();
export const NodeAPIWriteAPISchema: z.ZodType<NodeAPIWriteAPI> = NodeAPIWriteAPISchemaObject;
